
interface ProjectWrapperProps {
  children: React.ReactNode;
}

export default function ProjectWrapper({ children }: ProjectWrapperProps) {
  return <div className="l-project-wrapper">{children}</div>;
}
